import { createContext, useEffect, useState } from "react";
// import { getCountriesAndData } from "../utils/firebase.utils";

export const CountriesContext = createContext({
  countries: [],
});

export const CountriesProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://divyajyoti1801.github.io/Countries-API/data.json"
      ).then((response) => response.json());
      setCountries(response);
      return response;
    };
    fetchData();
  }, []);

  const value = {
    countries,
  };
  return (
    <CountriesContext.Provider value={value}>
      {children}
    </CountriesContext.Provider>
  );
};
